import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChartResult, Result, ResultList, SingleResult, StartProjectInput, StartProjectLogResult, StartProjectResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class StartProjectService {

  constructor(private httpClient: HttpClient) { }

  public addStartProject(startProjectInput: StartProjectInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'StartProject/AddStartProject', startProjectInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteStartProject(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'StartProject/DeleteStartProject?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getStartProjects(customerId: number, token: string): Promise<ResultList<StartProjectResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'StartProject/GetStartProjects?customerId=' + customerId, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<StartProjectResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<StartProjectResult>(), result.error));
  }

  public getStartProjectHistory(id: number): Promise<ResultList<StartProjectLogResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'StartProject/GetStartProjectHistory?startProjectId=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<StartProjectLogResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<StartProjectLogResult>(), result.error));
  }

  public getStartProject(id: number, token: string): Promise<SingleResult<StartProjectResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'StartProject/GetStartProject?id=' + id, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<StartProjectResult>(StartProjectResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<StartProjectResult>(StartProjectResult), result.error));
  }

  public getAllStartProjectReport(): Promise<ResultList<ChartResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'StartProject/GetAllStartProjectReport', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ChartResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ChartResult>(), result.error));
  }

  public updateAssignee(id: number, employeeId: number): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'StartProject/UpdateAssignee?id=' + id, employeeId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateIsDone(id: number, isDone: boolean): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'StartProject/UpdateIsDone?id=' + id, isDone, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }
}
